import React, { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";
import GenericNotification from "./GenericNotification";
import { NotificationProps } from "../FactoryNotification/FactoryNotification";

interface AdminMessageNotificationProps extends NotificationProps {
	item: {
		id: string, 
		notifMsg: string, 
		timestamp: number, 
		viewed: boolean,
		notifData: {
			message: string, 
			receivedFromType: string
		},
	}
} 

const AdminMessageNotification = ({ item, clickable, onSetNotificationAsView  }: AdminMessageNotificationProps) => {
	
	const { id, notifMsg, timestamp, viewed, notifData} = item
	const [numberTextLines, setNumberTextLines] = useState<number>(3);

	const { t } = useTranslation()

	const touchNotification =  useCallback(
	  () => {

		if(numberTextLines === 3)
			setNumberTextLines(100)
		else
			setNumberTextLines(3)
		
		if(!viewed)
			onSetNotificationAsView(id)
	  },
	  [numberTextLines],
	)

	return(
		<GenericNotification 
			touchNotification={touchNotification} 
			
			icon={"Wgimwork"}
			numberTextLines={numberTextLines}
			color={"#f00"}

			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={notifData.message}
			title={t("Notifications:index:label_36")}
		/>
	)

}

export default React.memo( AdminMessageNotification )